import { EventEmitter, Injectable } from "@angular/core";
import {  Platform} from 'ionic-angular';
import { OpenNativeSettings } from "@ionic-native/open-native-settings";
import { HttpProvider } from "../http/http";
import { APP_CONFIG, Region } from "../../environment";
import { UtilsProvider } from "../../providers/myria/utils-provider";
import { COUNTRY_SETTINGS, CUSTOMER_SETTINGS, EKYC_PROCESSOR_TYPE, KYC_ATTEMPT_STATUS, WALLET_ACTIVATION_RETVAL, WalletBalanceSN } from "../../providers/myria/app-variables";
import { LoginProvider } from "../../providers/myria/login-provider";
import { User, WalletDetails } from "../../model/myria/app/user";
import { DepositMethod,JomPay } from "../../model/myria/app/depositMethod";
import { CustomerProvider } from "../../providers/customer/customer";
import { LoggerEvent, LoggerProvider } from "../../providers/logger/logger";
import { Transaction, TRANSACTION_CATEGORY_TYPE, TRANSACTION_STATUS, WalletTransaction,WalletTransactionStatus } from '../../model/myria/app/transaction';
import { QRCodeInfo, WalletWithdrawOrPaymentInfo, WalletResetPinHeader,WalletWithdrawOrPaymentInfoMapper,BankAccount, EWalletRecipient, WalletValidatePinHeader, WALLET_RESPONSE, WALLET_SANDBOX_SETTING, WALLET_SANDBOX_BANK_STATUS, QrIDtype, QrCodeProvider, HELP_OPTION } from "../../model/models/wallet/wallet";
import { LimitFrequencyType, TransactionType } from "../../model/types/wallet-transactiontype-type";
import { WalletStatus } from "../../model/types/wallet-status";
import { RouteProvider } from "../../providers/route/route";
import { CallProvider } from "../../providers/call/call";
import { TranslateService } from '@ngx-translate/core';
import { AuthProvider } from "../../providers/authorization/auth";
import { StorageProvider } from '../../providers/storage/storage';
import { StorageType } from '../../model/types/storage-type';
import { WalletCardProvider } from "./wallet-card";
import { SegmentProvider } from "../../providers/analytics/segment";
import { TransactionStatus } from "../../model/types/wallet-transactionstatus-type";
import { PinActionType } from "../../model/types/wallet-pin-action-type";
import { AnalyticsEventType, AnalyticsWallet, ContactModalReasons, ContactType, HelpMethod, RoutedRail, SegmentLocationNames } from "../../model/types/analytics.const";
import { NumberFormatter } from "../../pipes/currency-pipe";
import { CARDTYPE, WALLETSTATUSSTRING, WALLETTRANSACTIONPERPAGE } from "../../model/models/wallet/wallet-card";
import { HelpProvider } from '../../providers/help/help';
import { ChatProvider } from '../../providers/zendesk/chat';
import { ContactsProvider } from '../../providers/contacts/contacts';
import { OrderProvider } from "../order/order";
import { PaymentMethodTypeID } from "../../model/types/payment-method-type";
import { LoadingProvider } from "../../providers/loading/loading";
import { OnfidoProvider } from "../myria/onfido-provider";
import { KYCProvider } from "../myria/kyc-provider";
import { RmtPopupComponent } from '../../components/rmt-popup/rmt-popup';
import { WalletVerificationStatus } from '../../model/types/wallet-verification-status';
import { FeatureFlagTypes } from '../../model/types/feature-flag-types';

@Injectable()
export class WalletProvider {
  Enabled: boolean = false;
  private depositMethods=null;
  walletUser=null;
  private walletUserPromise=null;
  private walletUserResolve=null;
  private walletUserRequestNr=0;
  private customersIdsArr=[];
  private customersIdsAutoSyncContactsArr=null;
  private isSyncContactCalledOneTime = false;
  private eWalletContacts: EWalletRecipient[] | null = null;
  private recentContactsCache: Promise<any> | null = null;
  phoneContactsPreload: Promise<void> | null = null;
  private walletActivatedInSession = false;
  private bankAccountsList = [];
  transcationsListHomePage = null;
  fullWalletBalanceLimit: number;
  fullWalletInflowMonthlyLimit: number;
  liteWalletBalanceLimit: number;
  liteWalletInflowLimit: number;
  private isWalletActivateFromSMF;
  isFromCreateProfile: boolean;
  onResumeCallBack =undefined;
  onResume;
  isWalletBalanceLoadedLogged:boolean = false;// this param to make sure logging segment event one time after login
  isWalletTransactionsLoadedLogged:boolean = false;// this param to make sure logging segment event one time after loginrmt
  forceUpdateWalletDeatails:boolean = false;
  firstRefresh:boolean = true;
  walletQRCodeString: string = "";
  walletDuitnowQRCodeString: string = "";
  walletDuitnowStaticQRImage: string = ""; // cached static DuitNow QR as a data URL
  private duitnowStaticQRImagePreloadInFlight: Promise<boolean> | null = null;
  private homeTransactionsInFlight: Promise<any> | null = null; // page-1 home transactions request, joined by callers with an empty cache
  private walletLimitInFlight: Promise<any> | null = null;
  duitnowQREnabledCache: boolean | null = null; // last-known DuitNow country-setting result (for instant seed)
  walletCountryLimits: Array<object> | null = null;
  isSelectingTransaction: boolean = false;

  // SN wallet feess cache (OM-18345). Persists across page nav so revisiting the same amount is instant.
  // 5-minute till it gets stalee
  private static readonly FEES_CACHE_TTL_MS = 300000;
  private feesCache: { [key: string]: { fees: any; timestamp: number } } = {};

  private buildFeesCacheKey(amount: number, transactionType: number): string {
    return `${amount}_${transactionType}`;
  }

  getCachedFees(amount: number, transactionType: number): any {
    if (!amount || !transactionType) return null;
    const entry = this.feesCache[this.buildFeesCacheKey(amount, transactionType)];
    if (entry && (Date.now() - entry.timestamp) < WalletProvider.FEES_CACHE_TTL_MS) {
      return entry.fees;
    }
    return null;
  }

  setCachedFees(amount: number, transactionType: number, feesItem: any) {
    if (!amount || !transactionType) return;
    const isUnwrappedFeesItem = feesItem
      && typeof feesItem === 'object'
      && (feesItem.TransactionFee !== undefined || feesItem.PercentFee !== undefined);
    if (!isUnwrappedFeesItem) return;
    this.feesCache[this.buildFeesCacheKey(amount, transactionType)] = { fees: feesItem, timestamp: Date.now() };
  }

  clearFeesCache() {
    this.feesCache = {};
    this.pendingFeesPromise = null;
    this.pendingFeesKey = '';
  }

  // Contact-details response cache (OM-18345). Avoids re-fetchingg wallet status for the same
  // phone number when the user picks → backs out → picks the same contact again in 5-mins range
  private static readonly CONTACT_DETAILS_CACHE_TTL_MS = 300000;
  private contactDetailsCache: { [key: string]: { details: any; timestamp: number } } = {};

  getCachedContactDetails(phoneNumber: string): any {
    if (!phoneNumber) return null;
    const entry = this.contactDetailsCache[phoneNumber];
    if (entry && (Date.now() - entry.timestamp) < WalletProvider.CONTACT_DETAILS_CACHE_TTL_MS) {
      return entry.details;
    }
    return null;
  }

  setCachedContactDetails(phoneNumber: string, details: any) {
    if (phoneNumber && details) {
      this.contactDetailsCache[phoneNumber] = { details: details, timestamp: Date.now() };
    }
  }

  clearContactDetailsCache() {
    this.contactDetailsCache = {};
  }

  // QR-driven prefetch. The QR scanner exit points know the amount and the action type
  // before wallet-withdraw-or-payment mounts; firing the BE fees call in parallel with the route push hidess
  private pendingFeesPromise: Promise<any> | null = null;
  private pendingFeesKey: string = '';

  prefetchFees(amount: number, transactionType: number): void {
    if (!amount || !transactionType || isNaN(amount) || amount <= 0) return;
    const key = this.buildFeesCacheKey(amount, transactionType);
    if (this.getCachedFees(amount, transactionType)) return;
    if (this.pendingFeesPromise && this.pendingFeesKey === key) return;
    this.pendingFeesKey = key;
    this.pendingFeesPromise = this.calculateFeesAndTaxForOfATransaction(amount, transactionType)
      .then((result) => {
        if (result && result.Result && result.Result.RetVal === 1 && result.Value && result.Value.length > 0) {
          this.setCachedFees(amount, transactionType, result.Value[0]);
        }
        return result;
      })
      .catch(() => null);
    LoggerProvider.info(this, `PerfFeesPrefetch start amount=${amount} type=${transactionType}`);
  }

  async consumePendingFees(amount: number, transactionType: number): Promise<any> {
    if (!amount || !transactionType) return null;
    const key = this.buildFeesCacheKey(amount, transactionType);
    if (this.pendingFeesPromise && this.pendingFeesKey === key) {
      const promise = this.pendingFeesPromise;
      this.pendingFeesPromise = null;
      this.pendingFeesKey = '';
      await promise;
      return this.getCachedFees(amount, transactionType);
    }
    return null;
  }

  deriveQrTransactionType(qrCodeInfo: any, actionType: string): number {
    if (!qrCodeInfo || !actionType) return 0;
    if (actionType === PinActionType.Withdraw) return TransactionType.WithdrawConfirmAtMerchant;
    if (actionType === PinActionType.Pay) {
      // QrCodeProviderr 2 = DuitNow
      return qrCodeInfo.QrCodeProvider === 2 ? TransactionType.PayDuitNow : TransactionType.MerchantPayment;
    }
    if (actionType === PinActionType.SendOrRequest) return TransactionType.Transfer;
    if (actionType === PinActionType.WithdrawToBank) return TransactionType.WallettoBankAccount;
    return 0;
  }

  cardTrnsTypeWithLabelList: Array<any> = [
    { type: TransactionType.CardPOS , label: 'page.eWalletPage.cardActivityPage.paidWithCardText' }, 
    { type: TransactionType.CardECOM , label: 'page.eWalletPage.transactionDetailsPage.onlinePaymentLabel' },
    { type: TransactionType.CardATMWithdrawal , label: 'page.eWalletPage.prepaidCardActivityPage.atmWithdrawalTitle'}, 
    { type: TransactionType.walletCardFee , label: 'page.eWalletPage.cardActivityPage.cardFeeLabel' }, 
    { type: TransactionType.CustomerPOSTransfer , label: 'page.eWalletPage.transactionDetailsPage.paymentLabel' }, 
    { type: TransactionType.CardEcommerceTransaction , label: 'page.eWalletPage.transactionDetailsPage.onlinePaymentLabel' }, 
    { type: TransactionType.RequestOrderReversal , label: 'page.activityPage.eWalletRefundLabel' },
    { type: TransactionType.CustomerDebit , label: 'page.eWalletPage.transactionDetailsPage.merchantPaymentLabel' }, 
    { type: TransactionType.WithdrawCash , label: 'page.eWalletPage.transactionDetailsPage.atmWithdrawalLabel' },
    { type: TransactionType.CreditAdjustment , label: 'page.activityPage.eWalletAdjustmentLabel_MY' }, 
    { type: TransactionType.CustomerFundRequest , label: 'page.eWalletPage.transactionDetailsPage.fundRequestLabel' },
    { type: TransactionType.BalanceEnquiry , label: 'page.activityPage.eWalletAdjustmentLabel_MY' }, 
    { type: TransactionType.RequestCashAdvance , label: 'page.activityPage.eWalletAdjustmentLabel_MY' },
    { type: TransactionType.CashAtCounter , label: 'page.activityPage.eWalletDepositLabel' }, 
    { type: TransactionType.CardIssuanceChargeVirtual, label: 'page.eWalletPage.transactionDetailsPage.virtualCardFeeLabel' },
    { type: TransactionType.CardEcommerceAccountVerification , label: 'page.activityPage.eWalletAdjustmentLabel_MY' }]

  walletMobileTopupType: Array<Number> = [ TransactionType.DomensticMobileTopup, TransactionType.InternationalMobileTopup];
  refundMobileTopupType: Array<Number> = [ TransactionType.DomensticMobileTopupFailed, TransactionType.InternationalMobileTopupFailed]
  billPaymentType: Array<Number> = [ TransactionType.BillPaymentDomestic, TransactionType.BillPaymentInternational]
  refundBillPaymentType: Array<Number> = [ TransactionType.BillPaymentDomesticRefund, TransactionType.BillPaymentInternationalRefund]
    
  isShowWalletBalance:boolean = true; //  on provider to keep it as it is on the whole session
  // Stops the tabs page auto-opening onboarding the customer just dismissed.
  onboardingDismissed: boolean = false;
  isWalletRetrieveFail: boolean = false; // use for EFT down
  isEFTWalletDown: boolean = false; // EFT not return wallet detail but get it from DB to not to blocking wallet

  private isForceReloadAccounts= false;
  constructor(private httpProvider: HttpProvider,
              private utilsProvider: UtilsProvider,
              private loginProvider: LoginProvider,
              private customerProvider: CustomerProvider,
              private routeProvider : RouteProvider,
              private callProvider : CallProvider,
              private translate: TranslateService,
              private platform: Platform,
              private walletCardProvider: WalletCardProvider,
              private analytics: SegmentProvider,
              private openNativeSettings: OpenNativeSettings,
              private storageProvider: StorageProvider,
              private currencyFormatter: NumberFormatter,
              private helpProvider: HelpProvider,
              private loadingProvider: LoadingProvider,
              private orderProvider: OrderProvider,
              private chatProvider: ChatProvider,
              private contactsProvider: ContactsProvider) {
                this.isShowWalletBalance = true;// default value 
                this.walletQRCodeString = "";
  }

  isEnabled() {
    return this.Enabled;
  }

  // master feature flag for wallet support
  isWalletSupportEnabled(): boolean {
    const enabled = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeWallet) === true;
    // mirror to RouteProvider so the SN/MY region rewrite can gate without
    // importing UtilsProvider/HttpProvider
    RouteProvider.walletSupportEnabled = enabled;
    return enabled;
  }

  async checkCountrySettings(): Promise<any> {
    
    let isWalletEnabled = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.ENABLE_WALLET);
    this.Enabled = isWalletEnabled === "1"? true : false;
    return this.Enabled;
  }

  hasWallet(): boolean {
    if (this.walletActivatedInSession) return true;
    if(APP_CONFIG.featureFlags.signinOld){
      const user = this.loginProvider.getUserUnsafe();
      if(user && user.HasRiaWallet)
        return true;
      else
        return false; // backward compatibility  // as remove user?wallet call
    }
    return this.httpProvider.getAuthIsWalletEnabled();
  }

  async isWalletActive(): Promise<boolean> {
    if(AuthProvider.isLoggedIn()){
      const wallet = await this.getWalletDetails();
      return this.checkUserWalletActive(wallet);
    }
    return false;
  }

  private checkUserWalletActive(wallet): boolean {
    if (wallet && wallet.Status !== WalletStatus.Inactive){
      return true;
    }
    return false;
  }

  // not really needed anymore since when a wallet gets permanently locked IsWalletEnabled will be set to false anyway
  async isWalletPermanentlyBlocked() {
    var status = await this.getWalletStatus();
    if (status === WalletStatus.PermanentBlocked){
      return true;
    }
    return false;
  }


  async isWalletTemporaryOrComplainceBlocked() {
    var status = await this.getWalletStatus();
    if (status === WalletStatus.ComplianceBlocked ||status === WalletStatus.TemporaryBlocked ){
      return true;
    }
    return false;
  }

  async isWalletBlocked(){
    var status = await this.getWalletStatus();
    if (status === WalletStatus.ComplianceBlocked ||status === WalletStatus.TemporaryBlocked || status === WalletStatus.PermanentBlocked ){
      return true;
    }
    return false;
  }

  async isWalletBlacklistedOrPermanentBlocked(){
    const walletDetails = await this.getWalletDetails();
    if (!walletDetails.IsDormant && walletDetails.Status === WalletStatus.BlackList || walletDetails.Status === WalletStatus.PermanentBlocked)
      return true;

    return false;
  }
  async getWalletStatus() {
    const walletDetails = await this.getWalletDetails();
    if (walletDetails && walletDetails.Status) {
      return walletDetails.Status;
    }
    return WalletStatus.Inactive;

  }

  async getWalletStatusInString(walletDetailsFromComp = null, fromSignin = false): Promise<string> {
    const walletDetails = walletDetailsFromComp ? walletDetailsFromComp : this.walletUser && this.walletUser.Value ? this.walletUser.Value : await this.getWalletDetails();
    this.setFirstRefresh(true);
    
    if (walletDetails && walletDetails.Status) {
      switch (walletDetails.Status) {
        case WalletStatus.Inactive:
          return WALLETSTATUSSTRING.INACTIVE;
        case WalletStatus.Active:
          return WALLETSTATUSSTRING.ACTIVE;
        case WalletStatus.TemporaryBlocked:
          return WALLETSTATUSSTRING.TEMPBLK;
        case WalletStatus.PermanentBlocked:
          return WALLETSTATUSSTRING.PERMBLK;
        case WalletStatus.Dormant:
          return WALLETSTATUSSTRING.DORMANT;
        case WalletStatus.ComplianceBlocked:
          return WALLETSTATUSSTRING.CMPLNCEBLK;
        default:
          return WALLETSTATUSSTRING.UNKNOWN;
      }
    }
    return WALLETSTATUSSTRING.INACTIVE;
  }

  private async getUser(): Promise<User> {
    if(AuthProvider.isLoggedIn()){
      const user = await this.loginProvider.getUserAsync();
      return user; //withoput user wallet  
    }
    return undefined;
  }

  async getWalletDetails(refreshUser:boolean = false): Promise<WalletDetails> {
    let requestNr = 0;
    
    try {
      if(!AuthProvider.isLoggedIn() || !this.hasWallet()) {
        return null;
      }

      // if no wallet user is available yet either force to get it or when it's already in progress wait for it despite the refreshUser
      if (!this.walletUser) {
        if (this.walletUserPromise)
          refreshUser = false;
        else
          refreshUser = true;
      }

      if (refreshUser) {
        requestNr = this.walletUserRequestNr + 1;
        if (requestNr > 10000)
          requestNr = 1;
        this.walletUserRequestNr = requestNr;
        this.isWalletRetrieveFail = false;
        if (!this.walletUserPromise || !this.walletUserResolve) {
          LoggerProvider.info(this, 'Starting wallet user request ' + requestNr + ' with new promise');
          this.walletUserPromise = new Promise((resolve) => {
            this.walletUserResolve = resolve;
          });
        } else
          LoggerProvider.info(this, 'Starting wallet user request ' + requestNr + ' without new promise');
  
        const walletUser = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/Wallet`);
        if (requestNr == this.walletUserRequestNr) {
          LoggerProvider.info(this, 'Finished wallet user request ' + requestNr);
          this.walletUser = walletUser;

          if (this.walletUser && this.walletUser.Value) {
            this.storeCachedWalletBalance(this.walletUser.Value);
            this.isEFTWalletDown = this.utilsProvider.normalizeToBoolean(this.walletUser.Value.Source ? this.walletUser.Value.Source : false); // EFT not return wallet detail but get it from DB to not to blocking wallet
            let walletCard = [];
            this.walletCardProvider.getWalletCardDetails(walletCard)
            if(this.walletUser.Value.Cards){
              this.walletUser.Value.Cards = this.walletCardProvider.setWalletCardDetailsVal(walletCard, this.walletUser.Value);
            }        
          } else if (walletUser.Result && walletUser.Result.RetVal == WALLET_RESPONSE.EFT_ERR_REEPONSE){ // EFT not return wallet detail
            this.isWalletRetrieveFail = true;
          }

          this.walletUserResolve(true);
          this.walletUserResolve = null;
        } else
          LoggerProvider.info(this, 'Skipped wallet user request ' + requestNr);
      }      
    } catch(ex) {
      if (requestNr == this.walletUserRequestNr) {
        LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Get Wallet details Failed for request nr ' + requestNr);
        window.setTimeout(() => {
          this.getWalletDetails(true);
        }, 1000);
      } else
        LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Get Wallet details Failed but skipped due to request nr ' + requestNr);
    }

    await this.walletUserPromise;

    if (this.walletUser && this.walletUser.Value)
      return this.walletUser.Value;
    return null;
  }

  async cancelWithdrawalRequest(transactionId): Promise<any> {
    try {
      const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/Wallet/Withdraw/cancel`, {transactionRef: transactionId});
      return result
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Cancel Withdrawal Request Failed');
      return null;
    }
  }

  async  getWalletTransactionHomePage(page: number, TransactionPerPage: number = null, refresh=false ,isVersion2: boolean = false): Promise<any> {
    try {
      // with an empty cache, join an in-flight page-1 request (e.g. the login prefetch) instead of starting another one
      if (!this.transcationsListHomePage && !refresh && page === 1 && this.homeTransactionsInFlight)
        await this.homeTransactionsInFlight;

      if(!this.transcationsListHomePage)
        refresh=true;
      if(refresh) {
        const request = this.getWalletTransactions(page,TransactionPerPage,isVersion2);
        if (page === 1)
          this.homeTransactionsInFlight = request;
        try {
          this.transcationsListHomePage = await request;
        } finally {
          if (this.homeTransactionsInFlight === request)
            this.homeTransactionsInFlight = null;
        }
      }
      if(this.transcationsListHomePage)
        return this.transcationsListHomePage;

      
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Get Wallet Home Transactions Failed');
      return null
    }
    return null;
  }

  async getWalletTransactions(page: number, TransactionPerPage: number = null, isVersion2: boolean = false): Promise<any> {
    try {
      let apiEndPoint =  APP_CONFIG.API_URL + (isVersion2 ? 'api/wallet/v2/transactions' : 'api/wallet/transactions');
      const transactions = await this.httpProvider.post(apiEndPoint, {
        CustomerId: this.httpProvider.getAuthCustomerId(),
        TransactionType: 1,
        Page: page,
        SearchKeyword: "",
        TransactionPerPage: TransactionPerPage
      });
      if (transactions) {
        return transactions
      }
    } catch(ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Get Wallet Transactions Failed');
      return null
    }
    return null
  }

  async shouldShowWalletWaitlist(): Promise<boolean> {
    const isNonPilotState = await this.utilsProvider.isSNNonPilotState(async () => this.customerProvider.getCustomer());
    if (!isNonPilotState || !this.hasWallet())
      return isNonPilotState;

    // wallet transactions never go away, so once seen for this customer skip waiting on the transactions call;
    // the login prefetch (prefetchWalletHome) still loads them for WalletHomePage.
    const customerId = this.httpProvider.getAuthCustomerId();
    if (await this.hasStoredWalletTransactions(customerId)) {
      this.setFirstRefresh(true);
      LoggerProvider.info(this, 'SN non-pilot state wallet holder has wallet transactions (stored)');
      return false;
    }

    // not awaited: getWalletDetails retries until api/Wallet answers, which must not hold up the login.
    // WalletHomePage joins this in-flight request instead of starting another one.
    this.getWalletDetails().catch((ex) => LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Wallet prefetch for waitlist check failed'));
    const transactions = await this.getWalletTransactionHomePage(1, WALLETTRANSACTIONPERPAGE.HOME, true);
    const hasTransactions = Array.isArray(transactions) && transactions.length > 0;
    if (hasTransactions) {
      this.setFirstRefresh(true);
      this.storageProvider.set(StorageType.SNWalletHasTransactions, JSON.stringify({ userId: customerId }));
    }
    LoggerProvider.info(this, `SN non-pilot state wallet holder ${hasTransactions ? 'has' : 'has no'} wallet transactions`);
    return !hasTransactions;
  }

  // the flag belongs to one user: a different user logging in on this device resets it.
  private async hasStoredWalletTransactions(customerId: any): Promise<boolean> {
    try {
      const storageObjStr = await this.storageProvider.get(StorageType.SNWalletHasTransactions);
      if (!storageObjStr || !customerId)
        return false;
      if (JSON.parse(storageObjStr).userId === customerId)
        return true;
      this.storageProvider.remove(StorageType.SNWalletHasTransactions);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed to read stored wallet transactions flag');
    }
    return false;
  }

  // not awaited: warms the caches WalletHomePage renders from (balance, first transactions page, limits),
  // so it can show them on arrival. Each call joins or reuses a request already made during login.
  prefetchWalletHome(): void {
    const onError = (ex: any) => LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Wallet home prefetch failed');
    this.getWalletDetails().catch(onError);
    this.getWalletTransactionHomePage(1, WALLETTRANSACTIONPERPAGE.HOME).catch(onError);
    this.getWalletLimit().catch(onError);
    // MY only (no-op elsewhere): DuitNow static QR (qrcode/create?issuer=2); WalletHomePage joins it or reads the cached image.
    this.preloadDuitnowStaticQRImage().catch(onError);
  }

  async activateWallet(txnPIN: string) {
    const result = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/Wallet/Activate`, {CustomerId: this.httpProvider.getAuthCustomerId(), TransactionPin: txnPIN});
    if (result.RetVal === WALLET_ACTIVATION_RETVAL.SUCCESS)
      this.walletActivatedInSession = true;
    return result;
  }

  async refreshUserWalletStatus(forceUpdate = false) {
    try {
      this.checkCountrySettings();
      if(forceUpdate)
        await this.loginProvider.infoClient(); // need to refresh User Object
      await this.getWalletDetails(true);
      
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Refresh Wallet Status Failed');
    }
  }
 
  async getDepositMethods(forceUpdate=false):Promise<DepositMethod[]>{
    if(this.depositMethods==null || forceUpdate)
      this.depositMethods = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/Wallet/Deposit/Methods`)
    return this.depositMethods
  }
  
  async  getJomPayData():Promise<JomPay> {
     let result =  await this.httpProvider.get(`${APP_CONFIG.API_URL}api/Wallet/Deposit/JomPay`);
     return result;
  }

  async validateQRCode(qrCode): Promise<QRCodeInfo> {
    try {
      const qrCodeInfo = await this.httpProvider.get(
        `${APP_CONFIG.API_URL}api/wallet/V2/QrCode/read`,
        {qrCodeString: encodeURIComponent(qrCode)}
      );
      return qrCodeInfo.Value;
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, "validateQRCode");
      return null;
    }
  }

  processWithdrawOrPayment(walletWithdrawOrPaymentInfo: WalletWithdrawOrPaymentInfo): Promise<any> {
    try {
      let endPoint = walletWithdrawOrPaymentInfo.ActionType === "withdraw" ? "Withdraw" : (walletWithdrawOrPaymentInfo.ActionType === PinActionType.Pay && walletWithdrawOrPaymentInfo.TransactionReferenceNumber) ? "CreditTransfer" : "Payment";
      const walletInfoForBodyRequest = WalletWithdrawOrPaymentInfoMapper.fromWalletInfoToWalletInfoForRequest(walletWithdrawOrPaymentInfo);
      return this.httpProvider.post(
        `${APP_CONFIG.API_URL}api/wallet/` + endPoint,
        walletInfoForBodyRequest,
        (res: any) => {
          return res;
        }
      );
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, "processWithdrawOrPayment");
      return null;
    }
  }

  processSendOrRequestMoney(walletWithdrawOrPaymentInfo: WalletWithdrawOrPaymentInfo): Promise<any> {
    try {
      const walletInfoForBodyRequest=WalletWithdrawOrPaymentInfoMapper.fromWalletInfoToWalletInfoForRequest(walletWithdrawOrPaymentInfo)
      return this.httpProvider.post(
        `${APP_CONFIG.API_URL}api/wallet/Transfer`,
        walletInfoForBodyRequest,
        (res: any) => {
          this.recentContactsCache = null; // the recipient may be new to the frequent list
          return res;
        }
      );
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, "processSendOrRequestMoney");
      return null;
    }
  }

  async isUserVerified():Promise<boolean>{
    const user = await this.getUser();
    return (user && user.IdentityVerification && user.IdentityVerification.Status === KYC_ATTEMPT_STATUS.VERIFIED);
  }

  async isUserCanTransactAndCanEKYC(): Promise<boolean> {
    const customer = await this.customerProvider.getCustomer();
    return (customer.kycStatus.canEKyc && customer.kycStatus.canTransact);
  }

  async getTransactionDetails(transactionID: string): Promise<any> {
    return await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/transaction?transactionRef=` + transactionID);
  }

  isTransactionTypeIsWithdrawal(transaction: any): boolean { 
    if (transaction.TransactionType === TransactionType.Withdraw
      || transaction.TransactionType === TransactionType.WithdrawRequest
      || transaction.TransactionType === TransactionType.WithdrawRequestAtMerchant
      || transaction.TransactionType === TransactionType.WithdrawConfirmAtMerchant
      || transaction.TransactionType === TransactionType.WithdrawConfirm) {
      return true;
    }
    return false;
  }

  async ResetPin(walletResetPinHeader: WalletResetPinHeader): Promise<any> {
    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/Wallet/ResetPin`, walletResetPinHeader,
      (res: any) => {
        return res;
      }
    );
  }

  async getContactDetails(phoneNumber): Promise<any> {
    try {
      const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet?mobile=`+ phoneNumber);
      if(result) return result;
      else return null;
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'getContactDetails Failed');
      return null;
    }
  }

  async getRecentContacts(): Promise<any> {
    try {
      const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/FrequentRecipients`);
      if(result && result.Value){
        return result.Value;
      } else {
        return null;
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'getRecentContacts Failed');
      return null;
    }
  }

  // Home preloads this in the background and the recipient list reuses it (or the call still in flight).
  // Reset on logout and after a wallet transfer.
  async getCachedRecentContacts(): Promise<any> {
    if (!this.recentContactsCache)
      this.recentContactsCache = this.getRecentContacts();
    const recentContacts = await this.recentContactsCache;
    if (!recentContacts)
      this.recentContactsCache = null; // failed, retry on the next call
    return recentContacts;
  }

  // Home reads the phone contacts in the background so the wallet contact list opens without the native read.
  // Only when auto-sync is on and the contacts prompt was already accepted, so it never prompts from home.
  async preloadPhoneContacts(): Promise<void> {
    if (this.eWalletContacts || this.phoneContactsPreload)
      return;
    this.phoneContactsPreload = this.readPhoneContacts();
    await this.phoneContactsPreload;
    this.phoneContactsPreload = null;
  }

  private async readPhoneContacts(): Promise<void> {
    try {
      const reason = this.contactsProvider.reasons.syncContacts;
      const canRead = await this.isAutoSyncContactsEnabled() && await this.contactsProvider.isPermissionAccepted(reason);
      if (!canRead)
        return;
      const contactsList = await this.contactsProvider.findContacts(reason, ['displayName', 'phoneNumbers'], { hasPhoneNumber: true, multiple: true });
      // skip if the user logged out meanwhile or the page already synced
      if (Array.isArray(contactsList) && AuthProvider.isLoggedIn() && !this.eWalletContacts)
        this.eWalletContacts = this.mapPhoneContacts(contactsList);
    } catch (ex) {
      // e.g. permission revoked in the OS settings; the page sync handles that when the user opens the list
      LoggerProvider.warning(this, LoggerEvent.Wallet, 'Failed to preload phone contacts', ex);
    }
  }

  // Maps native device contacts to wallet recipients (mobile numbers only), sorted by name
  mapPhoneContacts(contactsList: any[]): EWalletRecipient[] {
    const recipients: EWalletRecipient[] = [];
    (contactsList || []).forEach((contact) => {
      if (contact)
        recipients.push(...this.toPhoneRecipients(contact));
    });
    return recipients.sort((a, b) => {
      return a.FullNameFromDevice > b.FullNameFromDevice ? 1 : b.FullNameFromDevice > a.FullNameFromDevice ? -1 : 0;
    });
  }

  // One recipient per distinct mobile number, since a contact can hold more than one mobile
  private toPhoneRecipients(contact): EWalletRecipient[] {
    const name = contact.name || {};
    const firstName = name.givenName || '';
    const lastName = name.familyName || '';
    const mobileNumbers = (contact.phoneNumbers || [])
      .filter((phoneNumber) => this.isMobileNumber(phoneNumber))
      .map((phoneNumber) => this.toInternationalNumber(phoneNumber.value))
      // drop empty and repeated numbers; the same number often sits under both 'mobile' and 'iPhone'
      .filter((phoneNumber, index, all) => phoneNumber && all.indexOf(phoneNumber) === index);

    return mobileNumbers.map((phoneNumber) => {
      const recipient = new EWalletRecipient();
      recipient.FirstNameFromDevice = firstName;
      recipient.LastNameFromDevice = lastName;
      recipient.Initial = firstName.substring(0, 1) + lastName.substring(0, 1);
      recipient.FullNameFromDevice = firstName + ' ' + lastName;
      recipient.PhoneNumber = phoneNumber;
      recipient.IsContactExistsInPhone = true;
      return recipient;
    });
  }

  private isMobileNumber(phoneNumber): boolean {
    const type = (phoneNumber && phoneNumber.type ? phoneNumber.type : '').toLowerCase();
    return type.indexOf('mobile') > -1 || type === 'iphone' || type === 'cell';
  }

  // Device numbers come as local (0...), international (00...) or E.164 (+...); wallet lookups need E.164
  private toInternationalNumber(value: string): string {
    let phoneNumber = value || '';
    if (phoneNumber.indexOf('00') === 0)
      phoneNumber = '+' + phoneNumber.substring(2);
    else if (phoneNumber.indexOf('0') === 0)
      phoneNumber = '+' + phoneNumber.substring(1);
    return phoneNumber.replace(/[\s\-\(\)]/g, '');
  }

  async deleteWalletAction(transactionPin): Promise<any> {
    const result = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/wallet/manage`, {
      CustomerId: this.httpProvider.getAuthCustomerId(),
      TransactionPin: transactionPin,
      Operation: 2,
      Status: 3,
    });
    if (result) {
      return result
    }

    return null
  }

  showIdDoesnotMatchError(callBack) {
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        title: this.translate.instant("page.eWalletPage.forgotPIN.noMatchIDHeader"),
        subtitle: this.translate.instant("page.eWalletPage.forgotPIN.noMatchIDDescription"),
        primaryButtonText: this.translate.instant('global.tryAgainButton'),
        secondaryButtonText: this.translate.instant('global.callCustomerServiceButton'),
        trackEvent: AnalyticsEventType.ContactModalDisplayed, 
        trackParams: {
          location: SegmentLocationNames.Wallet,
          reason: ContactModalReasons.RiaWalletPinMismatch
        },
        img: 'assets/icons/warn-icon.svg', 
        imageWithCircle:true,
        showSecondaryButton: true,
        secondaryAction: this.onCallCustomerServiceClick.bind(this),
        primaryAction: callBack,
      },
      null
    );
  }

  onCallCustomerServiceClick() {
    this.callProvider.callCustomerService(SegmentLocationNames.Wallet, ContactModalReasons.RiaWalletPinMismatch);
  }

  showGenericError() {
    this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, {
      title: this.translate.instant("page.eWalletPage.walletErrorHeader"), subtitle:
        this.translate.instant("page.eWalletPage.walletErrorContent"),
      primaryButtonText: this.translate.instant("global.okButton")
    }, null);
  }

  logout() {
    this.depositMethods = null;
    this.walletUser = null;
    this.walletUserPromise = null;
    this.walletUserResolve = null;
    this.eWalletContacts = null;
    this.walletActivatedInSession = false;
    this.customersIdsArr = []; // clear the array at logout
    this.customersIdsAutoSyncContactsArr=null;
    this.isSyncContactCalledOneTime = false;// this because every time user will login we need to call sync contacts at least for one time 
    this.isWalletBalanceLoadedLogged = false;
    this.isWalletTransactionsLoadedLogged = false;
    this.isForceReloadAccounts = false;
    this.bankAccountsList = [];
    this.isShowWalletBalance = true;
    this.onboardingDismissed = false; // must not leak across sessions/users
    this.forceUpdateWalletDeatails = false;
    this.transcationsListHomePage = null;
    this.homeTransactionsInFlight = null;
    this.walletLimitInFlight = null;
    this.walletQRCodeString = ''; // WalletHomePage seeds its QR from this, so it must not carry over to the next user
    this.firstRefresh = false;
    this.walletCountryLimits = null;
    this.clearFeesCache();
    this.clearContactDetailsCache();
    this.recentContactsCache = null;
    this.phoneContactsPreload = null;
  }

  async isShowActivateWalletPopup():Promise <boolean>{
    const isWalletEnabled = await this.checkCountrySettings();
    if(isWalletEnabled){
      const customersIds = await this.storageProvider.get(StorageType.ShowActivateWalletPopup);
      let isCurrentUserFound = false;
      if(customersIds){
        const customerId = this.httpProvider.getAuthCustomerId();
        if (customerId) {
          this.customersIdsArr = customersIds.split(',');
        
          isCurrentUserFound = this.customersIdsArr.some( (id) =>
            id === customerId.toString()
          );
        }
      }
      return !isCurrentUserFound;
    } else {
      return isWalletEnabled;
    }
  }
  hideWalletPopup(){
    // depending on isShowActivateWalletPopup will be always called first so it will load this.customersIdsArr
    const customerId = this.httpProvider.getAuthCustomerId();
    if (customerId) {
      this.customersIdsArr.push(customerId.toString()); // the array init value at this provider is empty array 
      this.storageProvider.set(StorageType.ShowActivateWalletPopup,this.customersIdsArr.join());
    }
  }
  async isNonFPXPopup(){
    const customersIds = await this.storageProvider.get(StorageType.ShowNonFPXPopup);
    let isCurrentUserFound = false;
    if(customersIds){
      const customerId = this.httpProvider.getAuthCustomerId();
      if (customerId) {
        this.customersIdsArr = customersIds.split(',');
      
        isCurrentUserFound = this.customersIdsArr.some( (id) =>
          id === customerId.toString()
        );
      }
    }
    return !isCurrentUserFound;
  }
  hideNonFPXPopup(){
    // depending on isShowNonFPXPopup will be always called first so it will load this.customersIdsArr
    const customerId = this.httpProvider.getAuthCustomerId();
    if (customerId) {
      this.customersIdsArr.push(customerId.toString()); // the array init value at this provider is empty array 
      this.storageProvider.set(StorageType.ShowNonFPXPopup,this.customersIdsArr.join());
    }
  }
  showQRCameraSettingsError(onResumeCallBack=undefined){
    this.onResumeCallBack = onResumeCallBack;
    if(this.platform.is('cordova')){
      let subtitleKey='page.eWalletPage.cameraAccessIOSBody';// default ios
      if(this.platform.is('android')){
        subtitleKey = 'page.eWalletPage.cameraAccessAndroidBody';
      }
      this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, {
        title: this.translate.instant("page.eWalletPage.cameraAccessHeader"),
        subtitle: this.translate.instant(subtitleKey),
        primaryButtonText: this.translate.instant('global.settingsButton'),
        primaryAction:  this.openApplicationDetails.bind(this),
        secondaryButtonText: this.translate.instant('global.genericCancelButton'),
        showSecondaryButton : true
      }, null);
    } 
    else
      this.showQRGenericError();
  }
  showQRGenericError(){
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        title: this.translate.instant("page.eWalletPage.qRCodeErrorHeader"),
        subtitle: this.translate.instant("page.eWalletPage.qRCodeErrorContent"),
        primaryButtonText: this.translate.instant('global.okButton'),
      },
      null
    );
  }

  showWithdrawalQRPrompt(walletDetails: WalletDetails) {
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        title: this.translate.instant("page.eWalletPage.myScannerErrorModal.header"),
        subtitle: this.translate.instant("page.eWalletPage.myScannerErrorModal.body"),
        primaryButtonText: this.translate.instant("page.eWalletPage.myScannerErrorModal.withdrawalButton"),
        primaryAction: () => {
          this.routeProvider.setRoot(
            this.routeProvider.pages.WalletWithdrawStepsPage,
            { actionType: PinActionType.Withdraw, WalletDetails: walletDetails }
          );
        },
        secondaryButtonText: this.translate.instant("page.eWalletPage.myScannerErrorModal.cancelButton"),
        showSecondaryButton: true,
      },
      null
    );
  }

  showRetailPaymentUnavailablePrompt(primaryAction?: () => void) {
    this.routeProvider.openActionSheet(
      this.routeProvider.pages.ModalAlertPage,
      {
        title: this.translate.instant("page.eWalletPage.retailPaymentUnavailableModal.header"),
        subtitle: this.translate.instant("page.eWalletPage.retailPaymentUnavailableModal.body"),
        primaryButtonText: this.translate.instant("page.eWalletPage.retailPaymentUnavailableModal.gotItButton"),
        primaryAction,
      },
      null
    );
  }

  openApplicationDetails(){
    this.openNativeSettings.open('application_details').then((data)=>{
      if(!this.onResume){
        this.onResume=this.platform.resume.subscribe(()=>{
          if(this.onResumeCallBack)
            this.onResumeCallBack();
          this.onResume.unsubscribe();
          this.onResume = undefined;

        });
      }
      
      
    }).catch((error)=>{
      LoggerProvider.exception(this, error, LoggerEvent.ProviderException, 'Failed to open native settings');
    })
  }

  async getBankAccountsList(forceUpdate = true): Promise<BankAccount[]>{
    try {
      if(!AuthProvider.isLoggedIn()){
        return null;
      }
      if(!forceUpdate)
        return this.bankAccountsList;
      this.setForceReloadAccountsList(false);
      const response = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/PaymentAccount`);
        if(response &&  response.Result ){
          const result = response.Result;
          if(result.RetVal && result.RetVal ===1 && response.Value){
            this.bankAccountsList = response.Value;
            return this.bankAccountsList;
          }
          else if(result.RetVal && result.RetVal === 8022){
            this.bankAccountsList = [];
            return this.bankAccountsList;
          }
          else
            return null;
      } else {
        return null;
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, "Couldn't get the wallet banks list");
      return null;
    }
  }

  async  getBankAccountDetails(accountId) {
    const response = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/PaymentAccount/${accountId}`);
    if(response){
      return response;
    } else {
      return null;
    }
  }

  async validateBankAccount(bankId,accountNumber,countryID,bankCurrency){
    const response = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/PaymentAccount/Validate`, {
      BankId: bankId,
      PaymentAccountCountryId: countryID,
      PaymentAccountNumber: accountNumber,
      PaymentAccountCurrency: bankCurrency
    });
    if (response)
      return response;

    return null;
  }

  async validateUserBankAccount(reqbody){
    const response = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/PaymentAccount/ValidateUserAccount`, reqbody);
    if (response)
      return response;

    return null;
  }

  async addBankAccount(tokenId){ // this token got from BE from Validate api
    const response = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/PaymentAccount/Add`, {
      PaymentAccountTokenId:tokenId
    });
    if (response)
      return response;
    return null;
  }

  async updateBankAccount(accountId,tokenId){ // this token got from BE from Validate api
    const response = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/PaymentAccount/Update`, {
      PaymentAccountId:accountId,
      PaymentAccountTokenId:tokenId
    });
    if (response)
      return response;
    return null;
  }

  async deleteBankAccount(accountId){ 
    const response = await this.httpProvider.delete(`${APP_CONFIG.API_URL}api/PaymentAccount/Delete/${accountId}`);
    if (response)
      return response;
    return null;
  }

  isForceReLoadAccountsList(){
    return this.isForceReloadAccounts;
  }

  async setForceReloadAccountsList(force){
    this.isForceReloadAccounts = force;
  }

  async processWithdrawToBankAccount(walletWithdrawOrPaymentInfo: WalletWithdrawOrPaymentInfo){
    const response = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/Wallet/WalletToBank`,{
      TransactionAmount:walletWithdrawOrPaymentInfo.TransactionAmount,
      TransactionCurrency:walletWithdrawOrPaymentInfo.TransactionCurrency, 
      TransactionPin : walletWithdrawOrPaymentInfo.TransactionPin,
      PaymentAccountId: walletWithdrawOrPaymentInfo.AccountId,
      TransactionNotes: walletWithdrawOrPaymentInfo.TransactionNotes,
      DeviceId: walletWithdrawOrPaymentInfo.DeviceId,
      LoginType: walletWithdrawOrPaymentInfo.LoginType,
      TokenReference: walletWithdrawOrPaymentInfo.TokenReference
      });
      if(response)
        return response;
      return null;
  }

  async calculateFeesAndTaxForOfATransaction(transactionAmount?, transactionType?){
    let endParms:any; 
    endParms = (transactionAmount && transactionType )? `TransactionFee?TransactionAmount=${transactionAmount}&TransactionType=${transactionType}` : 'TransactionFee';
    const response = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/${endParms}`);
    if(response){
      return response;
    } else {
      return null;
    }
  }

  async isAutoSyncContactsEnabled():Promise <boolean>{
    const customersIds = await this.storageProvider.get(StorageType.SyncContactsAutomatically);
    let isCurrentUserFound = false;
    
    this.customersIdsAutoSyncContactsArr = [];
    if(customersIds){
      const customerId = this.httpProvider.getAuthCustomerId();
      if (customerId) {
        this.customersIdsAutoSyncContactsArr = customersIds.split(',');
      
        isCurrentUserFound = this.customersIdsAutoSyncContactsArr.some( (id) =>
          id === customerId.toString()
        );
      }
    }
    return isCurrentUserFound;
  }
  async depositInwardRemittance(payload) {
    try {
      const response = await this.httpProvider.post(`${APP_CONFIG.API_URL}api/Wallet/RemittancePayoutToWallet`, payload);
      if (response) return response;
    } catch(ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed to deposit inward remittance transactions');
      return null
    }
    return null
  }
  
  /*
  * this function to update that sync contact called for one time after login
  */
  // syncContactInitCalled(){
  //   this.isSyncContactCalledOneTime = true ;
  //   return this.isSyncContactCalledOneTime ;
  // }
  async enableAutoSyncContacts(){
    const customerId = this.httpProvider.getAuthCustomerId();
    if (customerId) {
      if (!this.customersIdsAutoSyncContactsArr)
        await this.isAutoSyncContactsEnabled();
      if (this.customersIdsAutoSyncContactsArr.indexOf(customerId.toString()) === -1) {
        this.customersIdsAutoSyncContactsArr.push(customerId.toString()); // the array init value at this provider is empty array 
        this.storageProvider.set(StorageType.SyncContactsAutomatically,this.customersIdsAutoSyncContactsArr.join());
      }
    }
    
  }

  async disableAutoSyncContacts(){
    if (!this.customersIdsAutoSyncContactsArr)
      await this.isAutoSyncContactsEnabled();
    const id =  this.httpProvider.getAuthCustomerId();
    if(id){
      const index = this.customersIdsAutoSyncContactsArr.indexOf(id.toString());
      if(index > -1){
        this.customersIdsAutoSyncContactsArr.splice(index,1);
        this.storageProvider.set(StorageType.SyncContactsAutomatically,this.customersIdsAutoSyncContactsArr.join());
      }
    }
  }
  setEWalletContacts(contacts){
    this.eWalletContacts = contacts;
  }

  getEWalletContacts(){
    return this.eWalletContacts;
  }
  getIconFor(transaction: WalletTransaction): string {
    switch (transaction.TransactionStatus) {
      case WalletTransactionStatus.Pending:
        if (transaction.TransactionType === TransactionType.WithdrawRequest
          || transaction.TransactionType === TransactionType.WithdrawRequestAtMerchant
          || transaction.TransactionType === TransactionType.RequestFund) {
          return 'assets/icons/wallet_withdraw_pending_new.svg';
        } else {
          return 'assets/icons/wallet_deposit_success.svg';
        }
      case WalletTransactionStatus.Completed:
        if (transaction.TransactionType === TransactionType.WithdrawConfirm
           || transaction.TransactionType === TransactionType.WithdrawConfirmAtMerchant
           || transaction.TransactionType === TransactionType.Withdraw
           || transaction.TransactionType === TransactionType.RemittancePayment
           || transaction.TransactionType === TransactionType.WithdrawAtMerchant
           || transaction.TransactionType === TransactionType.Transfer
           || transaction.TransactionType === TransactionType.SystemDebit
           || transaction.TransactionType === TransactionType.TransferToBank
           || transaction.TransactionType === TransactionType.MerchantCashOut
           || transaction.TransactionType === TransactionType.WallettoBankAccount
           || transaction.TransactionType === TransactionType.DuitNowP2PTransfer) {
          return 'assets/icons/wallet_withdraw_success.svg';
        } else if (transaction.TransactionType === TransactionType.Deposit
           || transaction.TransactionType === TransactionType.DepositAtMerchant
           || transaction.TransactionType === TransactionType.CustomerJomPayCashIn
           || transaction.TransactionType === TransactionType.MerchantJomPayCashIn
           || transaction.TransactionType === TransactionType.SystemCredit
           || transaction.TransactionType === TransactionType.CommissionCredit
           || transaction.TransactionType === TransactionType.RetailPaymentRefund
           || transaction.TransactionType === TransactionType.RemittancePaymentRefund
           || transaction.TransactionType === TransactionType.WalletFundedInwardRemittance || transaction.TransactionType === TransactionType.DuitNowFailed || transaction.TransactionType === TransactionType.DuitNowP2PTransferFailed
           || transaction.TransactionType === TransactionType.DuitNowQRReceive
           || transaction.TransactionType === TransactionType.CDMDeposit) {
          return 'assets/icons/wallet_deposit_success.svg';
        } else if(transaction.TransactionType === TransactionType.RequestFund){
          return 'assets/icons/wallet_withdraw_pending_new.svg';
        } else if (transaction.TransactionType === TransactionType.MerchantPayment 
          || transaction.TransactionType === TransactionType.MerchantToMerchantTransfer || transaction.TransactionType === TransactionType.PayDuitNow) {
          return 'assets/icons/wallet_merchant_success.svg';
        } else if(this.getTransactionTypeText(transaction) || transaction.TransactionType === TransactionType.walletCardFeeRefund){
            return 'assets/icons/card_purchase.svg';
        }else if(this.getWalletMobileToptupTransactionType(transaction) || this.getWalletMobileToptupRefundTransactionType(transaction)){
          return 'assets/icons/wallet-airtime.svg';
        }else {
          return 'assets/icons/wallet_transaction_unknown.svg';
        }
      case WalletTransactionStatus.Failed:
        return 'assets/icons/wallet_withdraw_cancelled.svg';
    }
  }

  async onTransactionDetailsClick(transaction,gotoHomeScreen=false) {
    let actionType = '';
    const checkCardTrnsType = this.getTransactionTypeText(transaction);
    const isWalletServicesType = this.getWalletMobileToptupTransactionType(transaction) || this.getWalletMobileToptupRefundTransactionType(transaction);
    const isBillPaymentType = this.getBillPaymentTransactionType(transaction) || this.getBillPaymentRefundTransactionType(transaction);

    if(checkCardTrnsType || isWalletServicesType || isBillPaymentType || transaction.TransactionType === TransactionType.walletCardFeeRefund){
        this.routeProvider.openModal(this.routeProvider.pages.WalletTranscationDetailPage, { 
          transaction: transaction, WalletDetails: await this.getWalletDetails(false) });
    }else{
      if (transaction.TransactionStatus === TransactionStatus.Pending && this.isTransactionTypeIsWithdrawal(transaction)) {
        actionType = PinActionType.Withdraw;
      } else {
        actionType = PinActionType.TransactionDetails;
      }
      this.routeProvider.openModal(this.routeProvider.pages.WalletWithdrawOrPaymentDetailsPage, { actionType: actionType, transaction: transaction, WalletDetails: await this.getWalletDetails(false), gotoHomeScreen: gotoHomeScreen });
    }
  }

  openWalletBlocked(reason,location){
    this.analytics.trackEvent({
      eventName: AnalyticsEventType.WalletLocked, analyticsData: {
        lockedReason: reason, location: location
      } });

      this.setForceUpdateWalletDeatails(true);
      this.routeProvider.openModal(
        this.routeProvider.pages.ModalAlertPage,
        {
          title: this.translate.instant("page.eWalletPage.walletLockedHeader"),
          subtitle: this.translate.instant("page.eWalletPage.forgotPIN.noMatchIDDescription"),
          showFullPage:true,
          primaryButtonText:this.translate.instant('page.eWalletPage.forgotPINButton') ,
          secondaryButtonText:this.translate.instant('global.gotItButton') ,
          img: 'assets/imgs/wrong.svg', 
          showSecondaryButton: true,
          showBack:false,
          primaryAction: ()=>{this.routeProvider.push(this.routeProvider.pages.VerifyIdentityPage, { actionType: PinActionType.ResetPIN, showForgotPINTitle: true });},
          secondaryAction: ()=>{this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage);},
          
        },
        null
      );
  }

  async ValidatePin(walletValidatePinHeader: WalletValidatePinHeader): Promise<any> {
    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/Wallet/validatepin`, walletValidatePinHeader,
      (res: any) => {
        return res;
      }
    );
  }

  getTransactionTypeText(transaction, isCheckType: boolean = true){
    let transactionType = this.translate.instant('page.eWalletPage.activityPage.transactionText');
    const cardTrnsType = this.cardTrnsTypeWithLabelList.filter((item) => (item.type === transaction.TransactionType));
    if(cardTrnsType && cardTrnsType[0]){
        transactionType = this.translate.instant(cardTrnsType[0].label);
    }
    if(isCheckType && cardTrnsType && cardTrnsType[0]) return true;
    else if(!isCheckType)  return transactionType;
    else return false;
  }

  async ManagePin(walletResetPinHeader: WalletResetPinHeader): Promise<any> {
    return this.httpProvider.post(`${APP_CONFIG.API_URL}api/Wallet/ManagePin`, walletResetPinHeader,
      (res: any) => {
        return res;
      }
    );
  }
  
  // TODO REMOVE ?
  setForceUpdateWalletDeatails(value){
    this.forceUpdateWalletDeatails=value;
  }

  setFirstRefresh(value){
    this.firstRefresh = value
  }

  isFirstRefresh(){
    return this.firstRefresh
  }

  getWalletMobileToptupTransactionType(transaction){
    const services = this.walletMobileTopupType.filter((item) => (item === transaction.TransactionType));
    return (services && services[0]) ? true : false;
  }

  getWalletMobileToptupRefundTransactionType(transaction){
    const services = this.refundMobileTopupType.filter((item) => (item === transaction.TransactionType));
    return (services && services[0]) ? true : false;
  }

  loadWalletModal(amount, viewCtrl) {
    this.routeProvider.openActionSheet(
        this.routeProvider.pages.ModalAlertPage,
        {
            image: "assets/icons/wallet-coin-icon.png",
            imageWithCircle: true,
            title: this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.addMoneyTitle'),
            subtitle: this.translate.instant('page.eWalletPage.prepaidCardIssuancePage.addMoneyText',{n:amount}),
            primaryButtonText: this.translate.instant('global.addMoneyButton'),
            showPrimaryButton: true,
            primaryAction: () => this.routeProvider.openModal(this.routeProvider.pages.WalletDepositPage),
            showSecondaryButton: true,
            secondaryButtonText: this.translate.instant('global.notNowButton'),
            secondaryAction: () => { viewCtrl.dismiss() },
            dismissFromSecondary: true,
        },
        null
    );
  }

  async setRecentContactsListObj(recentContacts){
    let recentContatcs = [];
    for (let contact of recentContacts) {
      let eWalletRecipient: EWalletRecipient = new EWalletRecipient();
      eWalletRecipient.FirstName = contact.FirstName || '';
      eWalletRecipient.LastName = contact.LastName || '';
      eWalletRecipient.Initial = '';
      if (eWalletRecipient.FirstName.length > 0) {
        eWalletRecipient.Initial = eWalletRecipient.FirstName.substring(0, 1);
      }
      if (eWalletRecipient.LastName.length > 0) {
        eWalletRecipient.Initial = eWalletRecipient.Initial + eWalletRecipient.LastName.substring(0, 1);
      }
      eWalletRecipient.FullName = eWalletRecipient.FirstName + " " + eWalletRecipient.LastName;
      eWalletRecipient.PhoneNumber = contact.Mobile;
      if (eWalletRecipient.PhoneNumber && eWalletRecipient.PhoneNumber.indexOf("+") === -1) {
        eWalletRecipient.PhoneNumber = "+" + eWalletRecipient.PhoneNumber;
      }
      // FrequentRecipients already carries the wallet status, so the contact details page can skip the lookup for active wallets
      eWalletRecipient.Status = contact.Status;
      eWalletRecipient.IsWalletUser = Number(contact.Status) === WalletStatus.Active;
      recentContatcs.push(eWalletRecipient);
    }
    return recentContatcs;
  }

  async isUserCanTransact(): Promise<boolean> {
    const customer = await this.customerProvider.getCustomer();
    const kycStatus = customer && customer.kycStatus;
    return kycStatus && kycStatus.canTransact ? kycStatus.canTransact : false;
  }

  setRootWalletActivationFailedUnknownModal(){
    let modalPage = this.routeProvider.pages.WalletActivationFailedUnknownPageModal;
    let targetParams = {
      primaryButtonAction: () => {this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage);},
      secondaryButtonAction: () => { this.callProvider.callCustomerService(); },
    };
    this.routeProvider.setRoot(modalPage,targetParams);    
  }

  async getCustomerQRCode(forceUpdate: boolean = true): Promise<any> {
    if(!this. walletQRCodeString || this. walletQRCodeString === "" || forceUpdate){
      this.walletQRCodeString = "";
      const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/qrcode/create`);
      if(result && result.Result && result.Result.RetVal === 1 && result.Value && result.Value.QrCodeString){
        this. walletQRCodeString = result.Value.QrCodeString;
        const customerId = this.httpProvider.getAuthCustomerId();
        const storageObj = { value: this.walletQRCodeString , userId: customerId};
        this.storageProvider.set(StorageType.WalletQrCodeString, JSON.stringify(storageObj));
      }
    }
    return this. walletQRCodeString;
  }

  // last known balance, kept per user so WalletHomePage can show it after a fresh login while api/Wallet refreshes it.
  private storeCachedWalletBalance(walletDetails: WalletDetails) {
    const customerId = this.httpProvider.getAuthCustomerId();
    if (!customerId)
      return;
    const storageObj = { userId: customerId, balance: walletDetails.WalletAvailableBalance, currency: walletDetails.WalletCurrencyCode };
    this.storageProvider.set(StorageType.WalletCachedBalance, JSON.stringify(storageObj));
  }

  async getCachedWalletBalance(): Promise<{ balance: any, currency: string }> {
    try {
      const storageObjStr = await this.storageProvider.get(StorageType.WalletCachedBalance);
      const customerId = this.httpProvider.getAuthCustomerId();
      if (storageObjStr && customerId) {
        const storageObj = JSON.parse(storageObjStr);
        if (storageObj.userId === customerId)
          return { balance: storageObj.balance, currency: storageObj.currency };
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed to read cached wallet balance');
    }
    return null;
  }

  async getCustomerQCodeFromStorage(): Promise<any>{
    const storageObjStr = await this.storageProvider.get(StorageType.WalletQrCodeString);
    const customerId = this.httpProvider.getAuthCustomerId();
    if(storageObjStr && customerId){
      const storageObj = JSON.parse(storageObjStr);
      if(storageObj.userId === customerId && storageObj.value){
        this. walletQRCodeString = storageObj.value;
        return this. walletQRCodeString;
      }
    }
    return null;
  }

  async getDuitnowQRCode(amount?: string, hideErrorModal: boolean = false, onRateLimited?: () => void): Promise<string> {
    try {
      let url =
        APP_CONFIG.API_URL +
        `api/wallet/qrcode/create?issuer=${QrCodeProvider.DuitNow}`;

      // only append txnAmt if amount exists
      if (amount !== undefined && amount !== null && amount !== '') {
        url += '&txnAmt=' + amount;
      }

      const result = await this.httpProvider.get(url);

      if (
        result &&
        result.Result &&
        result.Result.RetVal === 1 &&
        result.Value &&
        result.Value.QrCodeString
      ) {
        this.walletDuitnowQRCodeString = result.Value.QrCodeString;
        return this.walletDuitnowQRCodeString;
      } else if (!hideErrorModal && result && result.Result && result.Result.RetVal === WALLET_RESPONSE.QR_CODE_RATE_LIMITED) {
        if (onRateLimited) onRateLimited();
        const subtitle = this.translate.instant('page.eWalletPage.duitNowQR.qrLimitModal.body');
        this.routeProvider.openActionSheet(
          this.routeProvider.pages.ModalAlertPage,
          {
            image: 'assets/imgs/yellow-warning_bg_color.svg',
            title: this.translate.instant('page.eWalletPage.duitNowQR.qrLimitModal.header'),
            subtitle: subtitle.replace(/\\n/g, '<br>'),
            primaryButtonText: this.translate.instant('page.eWalletPage.common.button.gotIt'),
            showPrimaryButton: true,
            showFullPage: false,
            isModal: true,
            hideHeader: true,
          }, null
        );
      } else if (!hideErrorModal) {
        this.routeProvider.openActionSheet(
          this.routeProvider.pages.ModalAlertPage,
            {
              image: 'assets/imgs/yellow-warning_bg_color.svg',
              title: this.translate.instant('page.eWalletPage.duitNowQR.qrFailureModal.Header'),
              subtitle: this.translate.instant('page.eWalletPage.duitNowQR.qrFailureModal.Body'),
              primaryButtonText: this.translate.instant('global.gotItButton'),
              showPrimaryButton: true,
              showFullPage: false,
              isModal: true,
              hideHeader: true,
            }, null
          );
      }

      return '';
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, '[DuitNow QR] Failed to generate QR code');
      return '';
    }
  }

  // Use storage to store the static duitnow QR (mirrors getCustomerQRCode)
  // hideErrorModal = true to hide the failure modal (for background preloads).
  async getDuitnowStaticQRImage(forceUpdate: boolean = false, hideErrorModal: boolean = false): Promise<string> {
    if (this.walletDuitnowStaticQRImage && !forceUpdate) {
      return this.walletDuitnowStaticQRImage;
    }
    if (!forceUpdate) {
      const cached = await this.getDuitnowStaticQRImageFromStorage();
      if (cached) {
        return cached;
      }
    }
    const qrCodeString = await this.getDuitnowQRCode(undefined, hideErrorModal);
    if (qrCodeString) {
      this.walletDuitnowStaticQRImage = `data:image/png;base64,${qrCodeString}`;
      const customerId = this.httpProvider.getAuthCustomerId();
      const storageObj = { value: this.walletDuitnowStaticQRImage, userId: customerId };
      this.storageProvider.set(StorageType.WalletDuitnowStaticQrImage, JSON.stringify(storageObj));
    }
    return this.walletDuitnowStaticQRImage;
  }

  private async getDuitnowStaticQRImageFromStorage(): Promise<string> {
    const storageObjStr = await this.storageProvider.get(StorageType.WalletDuitnowStaticQrImage);
    const customerId = this.httpProvider.getAuthCustomerId();
    if (storageObjStr && customerId) {
      const storageObj = JSON.parse(storageObjStr);
      if (storageObj.userId === customerId && storageObj.value) {
        this.walletDuitnowStaticQRImage = storageObj.value;
        return this.walletDuitnowStaticQRImage;
      }
    }
    return '';
  }

  // Preload used by wallet home so the static QR is ready before the user opens the scanner.
  async preloadDuitnowStaticQRImage(): Promise<boolean> {
    if (this.duitnowStaticQRImagePreloadInFlight) {
      return this.duitnowStaticQRImagePreloadInFlight;
    }
    this.duitnowStaticQRImagePreloadInFlight = this.runDuitnowStaticQRImagePreload();
    try {
      return await this.duitnowStaticQRImagePreloadInFlight;
    } finally {
      this.duitnowStaticQRImagePreloadInFlight = null;
    }
  }

  private async runDuitnowStaticQRImagePreload(): Promise<boolean> {
    try {
      if (APP_CONFIG.region.region !== Region.MY) {
        return true; // not applicable — nothing to retry
      }
      if (this.walletDuitnowStaticQRImage) {
        return true; // already cached
      }
      if (!this.isDuitnowQRReleased()) {
        return true; // feature not released — no retry this session
      }
      const enabled = await this.isDuitnowQREnabledForCountry();
      if (!enabled) {
        return true; // disabled for this country — no retry
      }
      const image = await this.getDuitnowStaticQRImage(false, true); // hideErrorModal: hydrate from storage or fetch quietly
      return !!image; // false when the fetch failed → let the caller retry later
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, '[DuitNow QR] Failed to preload static QR');
      return false; // allow retry
    }
  }


  async getWalletLimit(): Promise<any> {
    if (this.walletCountryLimits) {
      return this.walletCountryLimits;
    }
    // join an in-flight request (e.g. the login prefetch) instead of starting another one
    if (!this.walletLimitInFlight)
      this.walletLimitInFlight = this.loadWalletLimit();
    try {
      return await this.walletLimitInFlight;
    } finally {
      this.walletLimitInFlight = null;
    }
  }

  private async loadWalletLimit(): Promise<any> {
    const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/Limits?getWalletLimits=True`);
    if(result && result.Value && result.Result.RetVal === 1 && result.Value.WalletLimits){
      this.walletCountryLimits = result.Value.WalletLimits;
      this.fullWalletBalanceLimit = this.getValueById(WalletBalanceSN.FULL_WALLET_BAL_LIMIT);
      this.fullWalletInflowMonthlyLimit = this.getValueById(WalletBalanceSN.FULL_WALLET_INFLOW_LIMIT);
      this.liteWalletBalanceLimit = this.getValueById(WalletBalanceSN.LITE_WALLET_BAL_LIMIT);
      this.liteWalletInflowLimit = this.getValueById(WalletBalanceSN.LITE_WALLET_INFLOW_LIMIT);
    }
    return this.walletCountryLimits;
  }

  async getJomPayDailyLimit(): Promise<any> {
    try {
      const result = await this.httpProvider.get(`${APP_CONFIG.API_URL}api/wallet/Limits?getTransactionLimits=True`);
      const limits = (result && result.Value && result.Value.TransactionLimits) || [];
      return limits.find(limit => limit.TransactionType === TransactionType.CustomerJomPayCashIn && limit.FrequencyType === LimitFrequencyType.Daily);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed to get JomPay daily limit');
      return null; // limits card stays hidden
    }
  }

  getValueById(id: number): number {
    const item: any = this.walletCountryLimits && this.walletCountryLimits.find(
      (limitItem: any) => limitItem.Id === id
    );
    return item ? Number(item.Value) : null;
  }

  showWalletBlockedPage(){
    this.routeProvider.openModal(this.routeProvider.pages.WalletBlackListedPage, {
      primaryButtonAction: () => {
        this.helpProvider.openHelp();
      }
    })
  }

  showWalletTempBlockedAndPinDisabledPage(loginName = ""){
    this.routeProvider.openModal(this.routeProvider.pages.WalletTempBlockedAndPinDisabledPage, {
      primaryButtonAction: () => {
        this.routeProvider.push(this.routeProvider.pages.WalletPinForgotPasscodeModalPage, { LoginName : loginName})
      }
    })
  }

  getIsCountrySupportDecimal(){
    return (APP_CONFIG.region.isCountrySupportDecimal) ? true : false; 
  }

  getFormattedTrnsAmount(amount: any, currency: string, isShowCurrency: boolean = true){
    const isCountrySupportDecimal:boolean = this.getIsCountrySupportDecimal();
    if(typeof amount === 'string') {
      if(!isCountrySupportDecimal){
        amount = Number(amount.replace('.', ''))
      } else {
        amount = parseFloat(amount.replace(/,/g, ''))
      }
    }
    if (amount < 0 || amount === 0){
      return !isShowCurrency ? amount : `${amount} ${currency}`;
    } else if(!isNaN(amount)){
      let formattedAmount: string;
      if(isCountrySupportDecimal) {
        formattedAmount= this.currencyFormatter.transform(amount, currency, false, true);
      } else {
        formattedAmount = this.currencyFormatter.transform(amount, currency);
      }
      return !isShowCurrency ? formattedAmount : `${formattedAmount} ${currency}`;
    } else return '';
  }
  
  async canShowWalletServices(){
    const walletDetails = await this.getWalletDetails();
    if(walletDetails && walletDetails.Status){
      var status = walletDetails.Status
      if (status === WalletStatus.TemporaryBlocked || status === WalletStatus.ComplianceBlocked ||
        walletDetails.Status === WalletStatus.Inactive || walletDetails.IsDormant ){
        return false;
      } else {
        return true;   
      }
    }
    return false;
  }

  async isWalletHasSufficientBalanceToTransact(transactionAmount){
    const walletDetails = await this.getWalletDetails();
    if(walletDetails && walletDetails.WalletAvailableBalance){
      if(transactionAmount < walletDetails.WalletAvailableBalance){
        return true;
      }
    }
    return false;
  }

  async getWalletStatusAsString(){
    var status = await this.getWalletStatus();
    let statusString = "";
    switch (status) {
      case WalletStatus.Active:
        statusString = "Active"
        break;
      case WalletStatus.Inactive:
        statusString = "Inactive"
        break;
      case WalletStatus.Dormant:
        statusString = "Dormant"
        break;
      case WalletStatus.ComplianceBlocked:
        statusString = "Compliance Block"
        break;
      case WalletStatus.TemporaryBlocked:
        statusString = "Temporary Block"
        break;
      case WalletStatus.PermanentBlocked:
        statusString = "Permanent Block"
        break;
      case WalletStatus.BlackList:
        statusString = "Blacklist"
        break;
      default:
        statusString = ""
        break;
    }
    return statusString;
  }

  async getWalletAvailableCardTypesAsStringArray(){
    let availableCardTypes = [];
    const walletDetails = await this.getWalletDetails();
    if(walletDetails && walletDetails.Cards && walletDetails.Cards.length > 0){
      for(let card of walletDetails.Cards) {
        if(card.CardType === CARDTYPE.PHYSICAL_CARD){
          availableCardTypes.push("Physical Card");
        } else if(card.CardType === CARDTYPE.VIRTUAL_CARD){
          availableCardTypes.push("Virtual Card");
        }
      }
    }
    return availableCardTypes;
  }

  async getWalletInfoForAnalytics(){
    let walletInfo:any = {};
    const walletDetails = await this.getWalletDetails();
    if(walletDetails){
      walletInfo.country = APP_CONFIG.region.region;
      walletInfo.walletBalance = walletDetails.WalletCurrentBalance;
      walletInfo.walletStatus = await this.getWalletStatusAsString();
      walletInfo.walletBalanceLimit = walletDetails.BalanceLimit;
    }
    return walletInfo;
  }

  async forgotWalletPasscode(payload): Promise<any> {
    try {
      return await this.httpProvider.post(`${APP_CONFIG.API_URL}api/Account/ForgotPasscode`, payload);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed Forgot Wallet Passcode');
      return ex;
    }
  }

  async validatePasscode(payload): Promise<any> {
    try {
      return await this.httpProvider.post(`${APP_CONFIG.API_URL}api/Account/ValidatePasscode`, payload);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed Reset Wallet Passcode');
      return ex;
    }
  }

  async resetWalletPasscode(payload): Promise<any> {
    try {
      return await this.httpProvider.post(`${APP_CONFIG.API_URL}api/Account/ManagePasscode`, payload);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed Reset Wallet Passcode');
      return ex;
    }
  }

  showSomethingWentWrongError(subTitle) {
    this.routeProvider.openActionSheet(this.routeProvider.pages.ModalAlertPage, {
      title: this.translate.instant('global.errorGeneralHeader'),
      subtitle: subTitle || '',
      primaryButtonText: this.translate.instant('global.gotItButton'),
    }, null);
  }

  getBillPaymentTransactionType(transaction){
    const services = this.billPaymentType.filter((item) => (item === transaction.TransactionType));
    return (services && services[0]) ? true : false;
  }

  getBillPaymentRefundTransactionType(transaction) {
    const services = this.refundBillPaymentType.filter((item) => (item === transaction.TransactionType));
    return (services && services[0]) ? true : false;
  }

  isShowEvents(transaction: Transaction){
    return !(transaction.PaymentMethod === PaymentMethodTypeID.PayNearMe || transaction.PaymentMethod === PaymentMethodTypeID.Cash);
  }

  async selectTransaction(transaction: Transaction, index) {
    let status = TRANSACTION_STATUS.PENDING;
    if (transaction.OrderStatusCategory === TRANSACTION_CATEGORY_TYPE.FUND_TRANSFER)
      status = TRANSACTION_STATUS.PENDING_FUNDS;
    else if (transaction.OrderStatusCategory === TRANSACTION_CATEGORY_TYPE.MONEY_RECEIVED)
      status = TRANSACTION_STATUS.COMPLETED;
    else if (transaction.OrderStatusCategory === TRANSACTION_CATEGORY_TYPE.TRANSFER_CANCELLED)
      status = TRANSACTION_STATUS.CANCELED;

    try {
      const orderPromise = this.orderProvider.getOrderStatus(transaction.OrderNo, false, false, true, true);
      this.routeProvider.openModal(this.routeProvider.pages.OrderDetailsPage,
        {
          orderPromise: orderPromise,
          showEvents: this.isShowEvents(transaction),
          transaction: transaction,
          location: 'activity',
          transferStatus: status,
          analyticsResendData: index ? {
            lineNumber: index
          } : null
        },() => {
        this.isSelectingTransaction = false;
      });
    } catch (ex) {
      RmtPopupComponent.showExceptionWithLogTranslation(this, ex, 'global.myRia.jsonContent.OopsInfo');
    }
  }

  async isSandBoxAvailable(){
    const enableSandbox = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.ENABLE_SANDBOX)
    return enableSandbox && enableSandbox == '1' ? true : false;
  }

  async isSandBoxCountry(){
    const userNationality = await this.getUserNationality();
    const sandboxCountry = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.SANDBOX_COUNTRY_LIST)
    let countryList = sandboxCountry ? sandboxCountry.split(",") : [];
    return countryList && userNationality ? (countryList.find(item=> (item.trim() == userNationality)) ? true : false) : false;
  }

  async getUserNationality(){
    const userCustomer = await this.loginProvider.getCustomerAsync();
    return (userCustomer && userCustomer.Nationality) ? userCustomer.Nationality.trim() : ''
  }

  async isUserNationalityMalaysia(): Promise<boolean> {
    const userNationality = await this.getUserNationality();
    return userNationality && userNationality === Region.MY;
  }

  async getSandboxBankValidationStatus(forceReload: boolean = false){
    await this.loginProvider.ensureInitializedUser(forceReload);
    return await this.loginProvider.getCustomerSettingAsync(WALLET_SANDBOX_SETTING.BANK_VALIDATION);
  }

  async getUserVisaType(){
    return await this.loginProvider.getCustomerSettingAsync(WALLET_SANDBOX_SETTING.CUSTOMER_VISA_CHECK);
  }

  async isSandboxUser(){
    const isSanboxUser =  await this.loginProvider.getCustomerSettingAsync(WALLET_SANDBOX_SETTING.IS_SANDBOX_USER);
    return isSanboxUser && isSanboxUser == '1' ? true : false
  }

  async isExceededSandBoxLimit(){
    const currentSandBoxUser = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.CURRENT_SANDBOX_COUNT)
    const maxLimit = await this.utilsProvider.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.MAX_SANDBOX_USE_COUNT)
    return (currentSandBoxUser && maxLimit) ? (Number(currentSandBoxUser) <= Number(maxLimit) ? false : true) : false;
  }

  async isUserVerifiedAtStore(){
    const user = await this.getUser();
    // MatchedByOnline & MatchedByCS are store verification processors
    return (user && user.IdentityVerification && (user.IdentityVerification.Processor === EKYC_PROCESSOR_TYPE.MatchedByCS || user.IdentityVerification.Processor === EKYC_PROCESSOR_TYPE.MatchedByOnline) && user.IdentityVerification.Status === KYC_ATTEMPT_STATUS.VERIFIED) ? true : false;
  }

  async isUserBnMVerified(): Promise<boolean> {
    const user = await this.getUser();
    return !!(user && user.IsF2fVerified);
  }

  async isUserBnMVerifiedWithValidId(): Promise<boolean> {
    const user = await this.getUser();
    return !!(user && user.IsF2fVerified && user.IsF2fIdValid);
  }

  async isUserVisaUnderProcess(){
    const isUserVisaUnderProcess = await this.loginProvider.getCustomerSettingAsync(WALLET_SANDBOX_SETTING.VISA_UNDER_PROCESS);
    return isUserVisaUnderProcess && isUserVisaUnderProcess == '1' ? true : false
  }

  async isUserEkycInProgress(): Promise<boolean> {
    const user = await this.getUser();
    return !!(user && user.IdentityVerification && user.IdentityVerification.Status === KYC_ATTEMPT_STATUS.IN_PROGRESS);
  }

  async isVisaSelectionAnswered(): Promise<boolean> {
    const user = await this.getUser();
    if (user && user.VisaApproved) {
      return true;
    }
    if (await this.isUserVisaUnderProcess()) {
      return true;
    }
    return await this.isUserVerified() || false;
  }

  showEkycInProgressScreen() {
    this.routeProvider.openModal(this.routeProvider.pages.OnfidoPendingPage, {}, this.closeWalletScreen());
  }

  async setSandboxUserOnfidoRoute(onfidoProvider: OnfidoProvider =  null, fromWalletActivate = false, location: string = '', isModal = false){
    this.loadingProvider.show();
    const isUserNationalityMalaysia = await this.isUserNationalityMalaysia();
    const isUserVerified = await this.isUserVerified();
    const isSandBoxAvailable = await this.isSandBoxAvailable();
    if (isUserVerified) {
      if(isSandBoxAvailable && !isUserNationalityMalaysia){
        const user = await this.loginProvider.getUserAsync();
        const isUserVisaUnderProcess = await this.isUserVisaUnderProcess();
        this.loadingProvider.hide();
        if(user && user.VisaApproved){
          this.openWalletActivationInfoModal(location);
        } else if(isUserVisaUnderProcess){
          const isFromSMF = this.getIsWalletActivateFromSMF();
          this.routeProvider.openModal(this.routeProvider.pages.SandboxVisaUnderReviewPage, {
            primaryButtonAction: (routeProvider: RouteProvider) => {
              isFromSMF ? routeProvider.setRoot(routeProvider.pages.CheckPricesPage) : routeProvider.setRoot(routeProvider.pages.TabsHomePage);
            }
          })
        } else {
            this.analytics.trackEvent({ eventName: AnalyticsEventType.DocUploadStarted, analyticsData: {}});
            this.routeProvider.openModal(this.routeProvider.pages.SandboxUploadVisaAlertPage, {}, this.closeWalletScreen());
        }
      } else{
        this.loadingProvider.hide();
        this.openWalletActivationInfoModal(location);
      }
    } else if (await this.isUserEkycInProgress()) {
      this.loadingProvider.hide();
      this.showEkycInProgressScreen();
    } else {
      this.loadingProvider.hide();
      let params = {
        onSuccess: () => {
          this.setSandboxUserOnfidoRoute(onfidoProvider, fromWalletActivate, location, isModal);
        },
        analyticsLocation: SegmentLocationNames.Activity,
        usWalletFlow: true, // marks the wallet-onboarding flow so US eKYC result screens use the wallet design
      };

      if (!fromWalletActivate && onfidoProvider) {
        const { CheckPricesPage, SendFinishPage } = this.routeProvider.pages;

        // define Send Money Flow origin pages
        const SMFPage =
          this.routeProvider.hasPage(CheckPricesPage) ? CheckPricesPage :
          this.routeProvider.hasPage(SendFinishPage) ? SendFinishPage :
          null;

        if (SMFPage) {
          onfidoProvider.setOriginPage(SMFPage);
        }
      }
      if (isModal) {
        this.routeProvider.openModal(this.routeProvider.pages.OnfidoInfoPage, params, this.closeWalletScreen());
      } else {
        this.routeProvider.replace(this.routeProvider.pages.OnfidoInfoPage, params);
      }
    }
  }

  closeWalletScreen() {

    if (this.isFromCreateProfile) {
      return () => {
        this.loadingProvider.show();
        this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage);
        this.loadingProvider.hide();
      }
    }

    return null;  
  }

  async getWalletActivate(location){
    try {
      this.loadingProvider.show();
      const getBankValidationStatus = await this.getSandboxBankValidationStatus(true);
      const user = await this.loginProvider.getUserAsync();
      const isUserEkycVerified = await this.isUserVerified() || false;
      const isUserEkycPending = await this.isUserEkycInProgress();
      const isUserVerifiedAtStore = await this.isUserVerifiedAtStore() || false;
      const isSandBoxAvailable = await this.isSandBoxAvailable();
      const identityVerification = user && user.IdentityVerification;
      const hasEkycAttemptsLeft = !!(identityVerification && identityVerification.AttemptsLeft && identityVerification.AttemptsLeft > 0);
      this.loadingProvider.hide();

      if (!isSandBoxAvailable) {
        // If SandBox is off then default to original flow
        const result = await this.isUserCanTransact();
        if (!result) {
          this.routeProvider.openModal(this.routeProvider.pages.WalletActivationFailedPage, {}, this.closeWalletScreen());
        } else {
          this.analytics.trackEvent({ eventName: AnalyticsEventType.WalletActivateStarted, analyticsData: { location } });
          this.routeProvider.openModal(this.routeProvider.pages.WalletNotActivePage, { isModal: true, sourceLocation: location }, this.closeWalletScreen());
        }
      } else if (isUserVerifiedAtStore){
        this.openWalletActivationInfoModal(location);
      } else if (isUserEkycVerified){
        this.checkBankValidation(getBankValidationStatus, location, true)
      } else if (hasEkycAttemptsLeft || isUserEkycPending) {
        const isUserNationalityMalaysia = await this.isUserNationalityMalaysia();
        if(isUserNationalityMalaysia || getBankValidationStatus) {
          this.checkBankValidation(getBankValidationStatus, location, true);
        } else {
          this.routeProvider.openModal(this.routeProvider.pages.SandboxDocumentSelectionPage, { isVisaCategorySelection: false, location: location }, this.closeWalletScreen());
        }
      } else {
        this.routeProvider.openModal(this.routeProvider.pages.verifyYourIdentityAtRiaStore, {
          primaryButtonAction: (routeProvider) => routeProvider.replace(routeProvider.pages.StoresPageNew, { showRiaStoresOnly: true })
        }, this.closeWalletScreen());
      }
    } catch(ex){
      this.routeProvider.openModal(this.routeProvider.pages.WalletActivationFailedPage, {}, this.closeWalletScreen());
      LoggerProvider.info(this, 'Wallet Activation Failed', ex);
    }
  }

  async checkBankValidation(getSandboxBankValidationStatus, location, fromWalletActivate = false, showRiaStoresOnly = true){
    if(getSandboxBankValidationStatus == WALLET_SANDBOX_BANK_STATUS.PASS || getSandboxBankValidationStatus == WALLET_SANDBOX_BANK_STATUS.PASS_FPX){
      await this.renderVisaScreenIfEnabled(null, fromWalletActivate, true, location);
    } else if(getSandboxBankValidationStatus == WALLET_SANDBOX_BANK_STATUS.SKIPPED){
      let getUserVisaType = await this.getUserVisaType();
      let isUserVisaUnderProcess = await this.isUserVisaUnderProcess();
      if(getUserVisaType || isUserVisaUnderProcess){
        if(getUserVisaType == WALLET_SANDBOX_SETTING.VISA_TYPE_EXPAT){
          this.routeProvider.openModal(this.routeProvider.pages.verifyYourIdentityAtRiaStore, {
            primaryButtonAction: (routeProvider) => routeProvider.replace(routeProvider.pages.StoresPageNew, { showRiaStoresOnly: showRiaStoresOnly })
          }, this.closeWalletScreen());
        } else {
          this.setSandboxUserOnfidoRoute(null, fromWalletActivate, location, true);
        }
      } else {
        await this.renderVisaScreenIfEnabled(null, fromWalletActivate, true, location);
      }
    } else if(getSandboxBankValidationStatus == WALLET_SANDBOX_BANK_STATUS.FAIL || getSandboxBankValidationStatus == WALLET_SANDBOX_BANK_STATUS.NOBANK){
      this.routeProvider.openModal(this.routeProvider.pages.verifyYourIdentityAtRiaStore, {
        primaryButtonAction: (routeProvider) => routeProvider.replace(routeProvider.pages.StoresPageNew, { showRiaStoresOnly: showRiaStoresOnly })
      }, this.closeWalletScreen())
    } else {
      this.routeProvider.openModal(this.routeProvider.pages.SandboxBankValidationPage , { location: location }, this.closeWalletScreen())
    }
  }

  openWalletActivationInfoModal(location){
    this.analytics.trackEvent({ eventName: AnalyticsEventType.WalletActivateStarted, analyticsData: { location: location } });
    this.routeProvider.openModal(this.routeProvider.pages.WalletNotActivePage, {isModal: true, sourceLocation: location}, this.closeWalletScreen());
  }

  // Common function to get wallet & card status in string for Segment Events
  async getWalletAndCardStatusSegEv(): Promise<{walletStatus: string, physicalCardStatus: string, virtualCardStatus: string}> {
    const walletStatus = await this.getWalletStatusInString();
    const cardStatuses = this.walletCardProvider.getCardStatusForSegmentEv();
    return {
      walletStatus,
      physicalCardStatus: cardStatuses ? cardStatuses.physicalCardStatus : null,
      virtualCardStatus: cardStatuses ? cardStatuses.virtualCardStatus : null
    }
  }

  setIsWalletActivateFromSMF(isWalletActivateFromSMF: boolean) {
    this.isWalletActivateFromSMF = isWalletActivateFromSMF;
  }

  getIsWalletActivateFromSMF() {
    return this.isWalletActivateFromSMF;
  }

  setPrepaidCardBannerDismissed() {
    this.storageProvider.set(StorageType.PrepaidCardBannerDismissed, '1');
  }

  setIsFromCreateProfile(isFromCreateProfile: boolean) {
    this.isFromCreateProfile = isFromCreateProfile;
  }

  async getPrepaidCardBannerDismissed(): Promise<string> {
    return await this.storageProvider.get(StorageType.PrepaidCardBannerDismissed);
  }

  setPendingOrderExpiredDismissed() {
    this.storageProvider.set(StorageType.PendingOrderExpiredDismissed, '1');
  }

  async getPendingOrderExpiredDismissed(): Promise<string> {
    return await this.storageProvider.get(StorageType.PendingOrderExpiredDismissed);
  }
  
  async verifyIdFromWallet(kycProvider: KYCProvider, source: string) {
    const trackInfo = {
      trackEvent: AnalyticsEventType.WalletUpgradeRequested,
      trackParams: { location: SegmentLocationNames.SendRemittance },
    };
    this.loadingProvider.show();
    await kycProvider.openKyc(trackInfo, source);
    this.loadingProvider.hide();
  }

  isQRDuitNowP2P(qrCodeInfo): boolean {
    if (!qrCodeInfo) return false;
    return (qrCodeInfo.QrCodeProvider === QrCodeProvider.DuitNow  && qrCodeInfo.IdType === QrIDtype.Customer) ? true : false;
  }
  // Whether DuitNow QR is enabled for the current country (country setting, not the rollout flag).
  // Caches the latest result in duitnowQREnabledCache.
  async isDuitnowQREnabledForCountry(): Promise<boolean> {
    const enabled = await this.utilsProvider.forceRefreshCountrySetting(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.ENABLE_DUITNOW_QR);
    this.duitnowQREnabledCache = enabled;
    return enabled;
  }

  // Whether Ria merchant QR (retail) payments are enabled for the current country (OM-21592).
  async isRetailPaymentEnabledForCountry(): Promise<boolean> {
    return this.utilsProvider.forceRefreshCountrySetting(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.ENABLE_WALLET_RETAIL_PAYMENT);
  }

  // Whether the DuitNow QR rollout feature flag is on. The underlying read is "unsafe" (can throw),
  // so it is wrapped here and returns a plain boolean, letting callers avoid their own try/catch.
  isDuitnowQRReleased(): boolean {
    try {
      return !!UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.rbe_release_duitnow_qr_enabled);
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Failed to read rbe_release_duitnow_qr_enabled flag');
      return false;
    }
  }

  setActiveWalletPin() {
    this.routeProvider.openModal(this.routeProvider.pages.WalletPinPage, { sourceLocation: 'Wallet Home' }, (pin) => this.onActivateWalletResult(pin, true));
  }

  async onActivateWalletResult(pin, isFromActiveWalletNoPinBanner = false) {
    if (!pin || pin === '' || pin === undefined) {
      return;
    }
    this.loadingProvider.show();
    try {
      const result = await this.activateWallet(pin);
      if (result.RetVal === WALLET_ACTIVATION_RETVAL.SUCCESS) {
        await this.refreshUserWalletStatus(true);
        const walletAndCardStatusData = await this.getWalletAndCardStatusSegEv();
        const pageToRender = isFromActiveWalletNoPinBanner ? this.routeProvider.pages.ActiveWalletPasscodeUpdatedPage : this.routeProvider.pages.WalletActivationSuccessPage;
        this.routeProvider.setRoot(pageToRender);
        LoggerProvider.info(this, 'Wallet Activation Success', result);
        this.analytics.trackEvent({ eventName: AnalyticsEventType.WalletActivationCompleted });
        this.analytics.trackEvent({ eventName: AnalyticsEventType.IdentifyWalletActivationCompleted, analyticsData: { 
          walletStatus: walletAndCardStatusData.walletStatus,
        }});
      } else if (result.RetVal === WALLET_ACTIVATION_RETVAL.ACCOUNT_EXISTS) {
        await this.refreshUserWalletStatus();
        this.routeProvider.setRoot(this.routeProvider.pages.WalletActivationSuccessPage);
        LoggerProvider.info(this, 'Wallet Activation already active', result);
      } else if ([WALLET_ACTIVATION_RETVAL.GENERIC_ERROR, WALLET_ACTIVATION_RETVAL.PROVIDER_COMMUNICATION_ERROR, WALLET_ACTIVATION_RETVAL.UNKOWN_ERROR].includes(result.RetVal)) {
        // OM-11315 - Scenario 1 (ret val 998 || 999 || 1000  - for Unknown Error) - show Oops screen
        await this.refreshUserWalletStatus();
        this.setRootWalletActivationFailedUnknownModal()
        LoggerProvider.info(this, 'Wallet Activation Failed (RetVal: 998 or 999, 1000)', result);
      } 
      else {
        // OM-11315 - Scenario 2, show eWallet Activation Failed screen
        await this.refreshUserWalletStatus();
        const params = {
          title: this.translate.instant('page.sendMoneyPaymentPage.eWalletActivationFailedHeader'),
          body: this.translate.instant('page.sendMoneyPaymentPage.eWalletActivationFailedContent')
        };
        this.routeProvider.replace(this.routeProvider.pages.WalletActivationFailedPage, params);
        LoggerProvider.info(this, 'Wallet Activation Failed', result);
      }
    } catch (ex) {
      this.loadingProvider.hide();
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Wallet Activation failed');
      this.setRootWalletActivationFailedUnknownModal()
    }
    this.loadingProvider.hide();
  }

 
  async fetchPendingOrderDetails() {
    try {
      LoggerProvider.info(this, 'Fetch Customer Setting for Pending Order');
      const pendingOrderDetails =
      await this.loginProvider.getCustomerSettingAsync(CUSTOMER_SETTINGS.PENDING_ORDER_DETAILS.TYPE);
      if (pendingOrderDetails) {
        LoggerProvider.info(this, 'Fetch Customer Setting for Pending Order Success', pendingOrderDetails);
        let pendingOrderMessage;
        let pendingOrderEkycTitle;
        let renderPendingOrderDetails;
        const orderDetailsArr = pendingOrderDetails.split(/\|/);
        if (orderDetailsArr) {
          const firstName =
            orderDetailsArr[0] ? orderDetailsArr[0].charAt(0).toUpperCase() +
            orderDetailsArr[0].slice(1) : '';
          const currency = orderDetailsArr[1] ? orderDetailsArr[1] : '';
          const amount = orderDetailsArr[2] ? orderDetailsArr[2] : '';

          pendingOrderMessage = this.translate.instant(
            "page.walletHomepage.pendingTransferMessage",
            { firstName, amount, currency }
          );
          pendingOrderEkycTitle = this.translate.instant(
            "page.walletAcceptTransferPage.acceptTransferHeader",
            { firstName, amount }
          );
          renderPendingOrderDetails = true;
          return {
            pendingOrderMessage,
            pendingOrderEkycTitle,
            renderPendingOrderDetails,
            firstName,
            currency,
            amount
          }
        }
      }
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.Wallet, 'Fetch Customer Setting for Pending Order Failed');
    }

  }

  async isPendingOrderExpired() {
    return await this.loginProvider.getCustomerSettingAsync(
        CUSTOMER_SETTINGS.PENDING_ORDER_EXPIRED.TYPE
      );
  }

  onGetPendingTransferClick(pendingOrderEkycTitle: string = '') {
    this.routeProvider.push(this.routeProvider.pages.PendingTransactionPage, {
      title: pendingOrderEkycTitle,
      primaryButtonAction: () => {
        let params = {
          analyticsLocation: SegmentLocationNames.PendingOrderEkycStartPage,
          showBack: true,
          showHelp: false,
          onSuccess: () => {
            this.routeProvider.setRoot(
              this.routeProvider.pages.IncomingTransactionPage
            );
          },
        };
        this.routeProvider.push(
          this.routeProvider.pages.OnfidoInfoPage,
          params
        );
      },
    });
  }


  determineP2Plocation(qrCodeInfo): AnalyticsWallet {
    let location = AnalyticsWallet.InApp;
    if (qrCodeInfo) location = this.isQRDuitNowP2P(qrCodeInfo) ? AnalyticsWallet.DuitNowQRScan : AnalyticsWallet.QRScan;
    return location
  }

  determineP2PRailAttribution(qrCodeInfo: any, response?: any): { routedRail: RoutedRail, isRiaToRia: boolean } {
    const isDuitNowQrP2P = this.isQRDuitNowP2P(qrCodeInfo);
    const onDuitNowRail = response && response.TransactionType 
      ? response.TransactionType === TransactionType.DuitNowP2PTransfer
        || response.TransactionType === TransactionType.DuitNowP2PTransferFailed
      : isDuitNowQrP2P;
    return {
      routedRail: onDuitNowRail ? RoutedRail.DuitNow : RoutedRail.ClosedLoop,
      isRiaToRia: !isDuitNowQrP2P
    };
  }

  whatsAppMessageLinkBuilder(phoneNumber: string, message: string): string {
    return `${APP_CONFIG.whatsappLink}/${phoneNumber}?text=${message}`;
  }

  async onClickUpgradeWalletLimit(kycProvider: KYCProvider){
    const trackInfo = {
          trackEvent: AnalyticsEventType.WalletUpgradeRequested,
          trackParams: { location: SegmentLocationNames.WalletCheckLimits },
    };
    this.loadingProvider.show();

    const status = await this.getLiteWalletVerificationStatus(kycProvider)

    if(status && status == WalletVerificationStatus.InProgress) {
      this.routeProvider.openModal(this.routeProvider.pages.OnfidoPendingPage);
      this.loadingProvider.hide();
    }

    else {
        await kycProvider.openKyc(trackInfo, "wallet-check-limits");
        this.loadingProvider.hide();
    }
  }

  async getLiteWalletVerificationStatus(kycProvider: KYCProvider) {
    /**
     * [OM-17404]
     * Determines the wallet verification status for upgrading from Lite to Full.
     * Currently used for SN users, with the intent to support other countries
     * with minimal customization in the future.
   */
    const walletDetails = await this.getWalletDetails();
    const isUserKyced = await kycProvider.isVeriffUserKyced();
    const KycStatus = await this.loginProvider.getKycStatus(!this.firstRefresh);
    const isManualVerified = kycProvider.isWalletManualVerified()
    const isManualVerificationExpired = kycProvider.isManualVerificationExpired()
    
    const isWalletKycEd = walletDetails.IsKycEd
    const isUserVerificationComplete = isUserKyced && isManualVerified

    const isInProgress =
      (isWalletKycEd && !isUserVerificationComplete) ||
      (!isWalletKycEd && (isUserKyced || isManualVerified) ||
      (KycStatus && KycStatus.attempt == KYC_ATTEMPT_STATUS.IN_PROGRESS)
    )

    if (isManualVerificationExpired) {
      return WalletVerificationStatus.Important
    }
    
    else if (isInProgress) {
      return WalletVerificationStatus.InProgress
    }

    else if(isWalletKycEd && isUserVerificationComplete) {
      return WalletVerificationStatus.Success
    }

    else return WalletVerificationStatus.Pending
  }

  async renderVisaScreenIfEnabled(onfidoProvider: OnfidoProvider = null, fromWalletActivate: boolean = false, isModal: boolean = false, location: string = ''){
    const params = { isVisaCategorySelection: true, location: location }
    const isVisaSelectionEnabled = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.SandboxVisaSelectionScreenEnabled);
    const isUserNationalityMalaysia = await this.isUserNationalityMalaysia();
    const isVisaSelectionAnswered = await this.isVisaSelectionAnswered();
    if (await this.isUserEkycInProgress()) {
      this.showEkycInProgressScreen();
    } else if (isVisaSelectionEnabled && !isUserNationalityMalaysia && !isVisaSelectionAnswered) {
      isModal ? this.routeProvider.openModal(this.routeProvider.pages.SandboxDocumentSelectionPage, params, this.closeWalletScreen()) :
      this.routeProvider.push(this.routeProvider.pages.SandboxDocumentSelectionPage, params);
    } else {
      this.setSandboxUserOnfidoRoute(onfidoProvider, fromWalletActivate, location, isModal);
    }
  }

  async openHelpActionSheet() {
    if (APP_CONFIG.region.region === Region.SN) {
      let availability = { isWithinOfficeHours: false, callAvailable: false, chatAvailable: false };
      try {
        availability = await this.chatProvider.getSupportAvailability();
      } catch (ex) {
        LoggerProvider.warning(this, LoggerEvent.GeneralException, 'Failed to fetch support availability');
      }

      const callDisabled = !availability.isWithinOfficeHours || !availability.callAvailable;
      const chatDisabled = !availability.isWithinOfficeHours || !availability.chatAvailable;

      let callSubTitle = 'page.eWalletPage.helpModal.callOptionBody';
      let chatSubTitle = 'page.eWalletPage.helpModal.chatOptionBody';

      if (!availability.isWithinOfficeHours) {
        callSubTitle = 'page.eWalletPage.helpModal.callOfficeHours';
        chatSubTitle = 'page.eWalletPage.helpModal.chatOfficeHours';
      } else {
        if (!availability.callAvailable) {
          callSubTitle = 'page.eWalletPage.helpModal.callDisabled';
        }
        if (!availability.chatAvailable) {
          chatSubTitle = 'page.eWalletPage.helpModal.chatDisabled';
        }
      }

      const isOfficeHours = availability.isWithinOfficeHours;
      const moreOptions = [
        {
          type: HELP_OPTION.CALL,
          title: this.translate.instant('page.eWalletPage.helpModal.callOptionHeader', { number: APP_CONFIG.SNHelplineNumber }),
          subTitle: callSubTitle,
          subtitleStyle: callDisabled ? 'red-text' : '',
          icon: 'assets/icons/telephone_black.png',
          sortOrder: 1,
          disabled: callDisabled,
          helpMethod: HelpMethod.Call,
          isAvailable: !callDisabled,
          isOfficeHours: isOfficeHours
        },
        {
          type: HELP_OPTION.CHAT,
          title: 'page.eWalletPage.helpModal.chatOptionHeader',
          subTitle: chatSubTitle,
          subtitleStyle: chatDisabled ? 'red-text' : '',
          icon: 'assets/icons/chat_bubble_black.svg',
          sortOrder: 2,
          disabled: chatDisabled,
          helpMethod: HelpMethod.Chat,
          isAvailable: !chatDisabled,
          isOfficeHours: isOfficeHours
        },
        {
          type: HELP_OPTION.HELP_CENTER,
          title: 'page.eWalletPage.helpModal.faqOptionHeader',
          subTitle: 'page.eWalletPage.helpModal.faqOptionBody',
          subtitleStyle: '',
          icon: 'assets/icons/globe_black.png',
          sortOrder: 3,
          disabled: false,
          helpMethod: HelpMethod.FAQ,
          isAvailable: true
        }
      ];
      const params = {
        title: this.translate.instant('page.eWalletPage.helpModal.header'),
        callBack: (option) => {
          this.analytics.trackEvent({
            eventName: AnalyticsEventType.HelpSelected,
            analyticsData: {
              helpMethod: option.helpMethod,
              isAvailable: option.isAvailable,
              isOfficeHours: option.isOfficeHours,
              country: APP_CONFIG.region.defaultCountryFrom
            }
          });

          if (option.disabled) return;
          if (option.type === HELP_OPTION.CALL) {
            this.callProvider.callNumber(APP_CONFIG.SNHelplineNumber, true, SegmentLocationNames.Wallet);
          } else if (option.type === HELP_OPTION.CHAT) {
            this.analytics.trackEvent({
              eventName: AnalyticsEventType.ContactButtonClicked,
              analyticsData: { contactType: ContactType.Chat, location: SegmentLocationNames.Wallet }
            });
            this.chatProvider.clickChatbot('', false, 'SN Wallet');
          } else if (option.type === HELP_OPTION.HELP_CENTER) {
            this.analytics.trackEvent({
              eventName: AnalyticsEventType.ContactButtonClicked,
              analyticsData: { contactType: ContactType.HelpCenter, location: SegmentLocationNames.Wallet }
            });
            var helpUrl = this.translate.instant('global.linkHelpURL');
            if (helpUrl && helpUrl.indexOf('NOT FOUND') === -1) {
              helpUrl = helpUrl + (helpUrl.indexOf('?') === -1 ? '?' : '&') + 'source=sn_wallet';
              this.routeProvider.openIab(helpUrl, {}, true, true);
            } else {
              this.helpProvider.openHelp();
            }
          }
        },
        moreOptions
      };
      this.routeProvider.openActionSheet(this.routeProvider.pages.WalletActionsMorePage, params, null, 'help-actionsheet');
    } else {
      this.helpProvider.openHelp();
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/wallet/wallet.ts